import { useEffect } from 'react';

import { messageDisplayFullscreen } from 'src/data/infinity';
import { sendMessageToParent } from 'src/lib/messages';
import { createStateSelectorHook } from 'src/lib/sweetState';
import { UiStore } from 'src/store';

/**
 * Notify Extension that Platform displays fullscreen popup
 */
const useUiState = createStateSelectorHook(UiStore, [
  'globalPopupVisibleCount',
  'localPopupVisibleCount',
]);
export const useReactToFullscreenPopups = () => {
  const { globalPopupVisibleCount, localPopupVisibleCount } = useUiState();

  useEffect(() => {
    const fullscreenPopupVisible = globalPopupVisibleCount > 0 || localPopupVisibleCount > 0;
    const message = messageDisplayFullscreen(fullscreenPopupVisible);
    sendMessageToParent(message);
  }, [globalPopupVisibleCount, localPopupVisibleCount]);
};
